export default "__VITE_ASSET__DdWl8Smb__"